module.exports = __webpack_public_path__ + "img/smok_vape_4.03b54f68.png";